import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-payment-success-modal',
  templateUrl: './payment-success-modal.component.html',
  styleUrls: ['./payment-success-modal.component.scss']
})
export class PaymentSuccessModalComponent implements OnInit {

  /**
   * Is payment created
   */
  isCreated: any;

  constructor(
    public dialogRef: MatDialogRef<PaymentSuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.isCreated = this.data.create;
    if (!this.data.guest) {
      setTimeout(() => {
        this.dialogRef.close({create: false, paymentMethod: null});
      }, 3000);
    }
  }
}
